import axios from "axios";
import React, { useEffect, useState } from "react";
import { useJwt } from "react-jwt";
import { useNavigate } from "react-router-dom";
import folderIcon from "../assets/img/ICON_ALIADAS/FOLDER/FOLDER-#37285f.png";
import { Claims } from "../security/ProtectedRouteAdmin";
import dashboard from "../styles/dashboard.module.css";
import "../styles/global.css";
import { URL_SERVER } from "../utils/Utils";
import secureLocalStorage from "react-secure-storage";
import { useDashboardTrash } from "../hooks/UseDashboardTrashAdmin";
import Sidebar from "./Sidebar";





const DashboardTrash: React.FC = () => {

  const {
  // estados
    nameSearch, setNameSearch,
    files, folders,
    showModal, setShowModal,
    newFolderName, setNewFolderName,
    showPolicyModal, setShowPolicyModal,
    sidebarOpen, setSidebarOpen,
    showOptions, setShowOptions,
    viewMode, setViewMode,
    openMenuKey, setOpenMenuKey,
    showUploadFileModal, setShowUploadFileModal,
    selectedFile, setSelectedFile,
    showEditModal, setShowEditModal,
    editName, setEditName,
    editItemId, setEditItemId,
    editIsFolder, setEditIsFolder,
    // navegación
    goToMainDashboard,
    goToAdmin,
    // tema
    isNight,
    toggleNightMode,
    icons: {
      logoActual,
      switchRightActual,
      moonIconActual,
      lupaActual,
      questionActual,
      logoutActual,
      borrarActual,
      restoreActual,
      goBackActual,
      folderActual
    },
    // funciones
    getFileIcon,
    allItems,
    fetchData,
    fetchDataFiltered,
    toggleItemMenu,
    handleDelete,
    handleRestore,
    isAdmin,
    token,
    navigate,
  } = useDashboardTrash();
  
  const { decodedToken } = useJwt<Claims>(token || "");


  return (
    <div className={dashboard.container}>
      {showModal && (
        <div className={dashboard.modal_overlay}>
          <div className={dashboard.modal}>
            <h3>Nueva carpeta</h3>
            <input
              type="text"
              placeholder="Nombre de la carpeta"
              value={newFolderName}
              onChange={(e) => setNewFolderName(e.target.value)}
              className={dashboard.modal_input}
            />
            <div className={dashboard.modal_buttons}>
              <button onClick={() => setShowModal(false)}>Cancelar</button>
              <button
                onClick={async () => {
                  if (!token) {
                    return;
                  }

                  try {
                    const parts = token.split(".");
                    if (parts.length !== 3) throw new Error("Token mal formado");

                    const payloadBase64 = parts[1];
                    const decodedPayload = JSON.parse(atob(payloadBase64));

                    const userId = decodedPayload?.id ?? decodedPayload?.user_id ?? decodedPayload?.sub;
                    if (!userId) {
                      return;
                    }

                    await axios.post(
                      `${URL_SERVER}/v2/folders`,
                      {
                        name: newFolderName,
                        creation_user_id: userId,
                      },
                      {
                        headers: {
                          Authorization: `Bearer ${token}`,
                          "Content-Type": "application/json",
                        },
                      }
                    );

                    await fetchData();

                    setNewFolderName("");
                    setShowModal(false);
                  } catch (error: any) {
                    console.error("Error al crear carpeta:", error);
                  }
                }}
              >
                Crear
              </button>
            </div>
          </div>

        </div>
      )}

      {showPolicyModal && (
        <div className={dashboard.modal_overlay}>
          <div className={dashboard.modal}>
            <h3>¿Para qué sirve este espacio?</h3>
            <div className={dashboard.modal_content}>
              <p>
                En este espacio podrás guardar, organizar y compartir
                toda la documentación e información vinculada a los
                proyectos del Programa Aliadas de la Dirección
                General de Juventud del Gobierno de Canarias.
              </p>
            </div>
            <div className={dashboard.modal_buttonss}>
              <button onClick={() => setShowPolicyModal(false)}>Cerrar</button>
            </div>
          </div>
        </div>
      )}

      {showUploadFileModal && (
        <div className={dashboard.modal_overlay}>
          <div className={dashboard.modal}>
            <h3>Subir Archivo</h3>
            <input
              type="file"
              onChange={(e) => {
                const file = e.target.files?.[0];
                if (file) {
                  setSelectedFile(file);
                }
              }}
              className={dashboard.modal_input}
            />

            <div className={dashboard.modal_buttons}>
              <button onClick={() => setShowUploadFileModal(false)}>Cancelar</button>
              <button
                onClick={async () => {
                  if (!selectedFile) {
                    return;
                  }

                  if (!token) {
                    return;
                  }

                  try {
                    const parts = token.split(".");
                    if (parts.length !== 3) throw new Error("Token mal formado");

                    const payloadBase64 = parts[1];
                    const decodedPayload = JSON.parse(atob(payloadBase64));

                    const userId = decodedPayload?.id ?? decodedPayload?.user_id ?? decodedPayload?.sub;
                    if (!userId) {
                      return;
                    }

                    const formData = new FormData();
                    formData.append("file", selectedFile);
                    formData.append("creation_user_id", userId);

                    await axios.post(`${URL_SERVER}/v2/files`, formData, {
                      headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "multipart/form-data",
                      },
                    });

                    await fetchData();
                    setSelectedFile(null);
                    setShowUploadFileModal(false);
                  } catch (error) {
                    console.error("Error al subir archivo:", error);
                  }
                }}
              >
                Subir
              </button>

            </div>
          </div>
        </div>
      )}

      {showEditModal && (
        <div className={dashboard.modal_overlay}>
          <div className={dashboard.modal}>
            <h3>Editar nombre</h3>
            <input
              type="text"
              placeholder="Nuevo nombre"
              value={editName}
              onChange={(e) => setEditName(e.target.value)}
              className={dashboard.modal_input}
            />
            <div className={dashboard.modal_buttons}>
              <button onClick={() => setShowEditModal(false)}>Cancelar</button>
              <button
                onClick={async () => {
                  if (!editItemId) return;

                  if (!token) {
                    return;
                  }

                  try {
                    await axios.put(`${URL_SERVER}/v2/${editIsFolder ? 'folders' : 'files'}/${editItemId}`, {
                      name: editName,
                      foldersUsers: [],
                      foldersFiles: [],
                    }, {
                      headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                      }
                    });

                    await fetchData();
                    setShowEditModal(false);
                    setEditName("");
                    setEditItemId(null);
                  } catch (err) {
                    console.error("Error al editar nombre:", err);
                    alert("Error al editar. Revisa la consola.");
                  }
                }}
              >
                Guardar
              </button>
            </div>
          </div>
        </div>
      )}



      <aside
        className={`${dashboard.sidebar} ${sidebarOpen ? dashboard.sidebarActive : ""
          }`}
      >
        <div className={dashboard.newButtonContainer}>
          <button
            className={dashboard.newButton}
            onClick={() => setShowOptions(!showOptions)}
          >
            + Nuevo
          </button>
          {showOptions && (
            <div className={dashboard.optionsMenu}>
              <div
                onClick={() => {
                  setShowModal(true);
                  setShowOptions(false);
                }}
              >
                Nueva Carpeta
              </div>
              <div
                onClick={() => {
                  setShowUploadFileModal(true);
                  setShowOptions(false);
                }}
              >
                Subir Archivo
              </div>
            </div>
          )}

          {
            isAdmin &&
            <div className={dashboard.newButtonContainer}>
              <button
                className={dashboard.newButton}
                onClick={() => goToAdmin()}
              >
                + Panel de administración
              </button>
            </div>
          }

          <Sidebar token={token} isAdmin={isAdmin} goToAdmin={goToAdmin} />
        </div>
      </aside>

      <main className={dashboard.content}>
        <header>
          <span
            className={`${dashboard.menuToggle} menuToggle`}
            onClick={() => setSidebarOpen(!sidebarOpen)}
          >
            &#9776;
          </span>
          <h2 className={dashboard.Bienvenidos}>
            <p className="BienvenidosTitulo">Bienvenidas a</p>
            <img className={dashboard.logo} src={logoActual} alt="logo" />
          </h2>

          <div className={`${dashboard.search_bar} search_bar`}>
            <input
              type="text"
              placeholder="Buscar"
              className="search_input"
              onChange={(e) => setNameSearch(e.target.value)}
            />
            <button onClick={() => fetchDataFiltered(nameSearch)}>
              <img
                src={lupaActual}
                className={`${dashboard.search_icon} search_icon`}
                alt="Buscar"
              />
            </button>
          </div>



          <div className={dashboard.icons}>
            <a onClick={() => setShowPolicyModal(true)}>
              <img src={questionActual} className={dashboard.iconos} alt="FAQ" />
            </a>
            <a onClick={toggleNightMode}>
              <img src={switchRightActual}
                className={dashboard.iconos}
                alt="switch"
              />
            </a>
            <img
              src={moonIconActual}
              className={dashboard.iconos}
              alt="Modo Día/Noche"
            />
            <a onClick={() => navigate("/user")}>
              <img
                src={logoutActual}
                className={dashboard.iconos}
                alt="Cerrar sesión"
              />
            </a>
          </div>
        </header>
        <button
          className={dashboard.viewToggle}
          onClick={() =>
            setViewMode(viewMode === "list" ? "grid" : "list")
          }
        >
          {viewMode === "list" ? "Mosaico" : "Lista"}
        </button>

        {viewMode === "list" ? (
          <div className={dashboard.tableResponsive}>
            <table border={1} className={dashboard.tablaprinc}>
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Fecha de Creación</th>
                  <th>Última Actualización</th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {files.length + folders.length > 0 ? (
                  <>
                    {folders.map((folder) => (
                      <tr key={`folder-${folder.id}`}>

                        <td>
                          <img
                            src={folderActual}
                            className={dashboard.iconosfila}
                            alt="Modo Día/Noche"
                          />
                          {folder.name}
                        </td>
                        <td>{new Date(folder.creation_date).toLocaleDateString()}</td>
                        <td>{new Date(folder.last_update_date).toLocaleDateString()}</td>
                        <td><img src={restoreActual} className={dashboard.iconosTabla} onClick={() => handleRestore(folder.id, true)} alt="" /></td>
                        <td><img src={borrarActual} className={dashboard.iconosTabla} alt="" onClick={() => handleDelete(folder.id, true)} /></td>
                      </tr>
                    ))}
                    {files.map((file) => (
                      <tr key={`file-${file.id}`}>
                        <td>{file.name}</td>
                        <td>{new Date(file.creation_date).toLocaleDateString()}</td>
                        <td>{new Date(file.last_update_date).toLocaleDateString()}</td>
                        <td><img src={restoreActual} className={dashboard.iconosTabla} onClick={() => handleRestore(file.id, false)} alt="" /></td>
                        <td><img src={borrarActual} className={dashboard.iconosTabla} onClick={() => handleDelete(file.id, false)} alt="" /></td>
                      </tr>
                    ))}
                  </>
                ) : (
                  <tr className={dashboard.noItemsRow}>
                    <td colSpan={5}>No hay elementos disponibles</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        ) : (
          <div className={dashboard.gridContainer}>
            {allItems.map((item) => {
              const itemKey = `${item.isFolder ? "folder" : "file"}-${item.id}`;
              return (
                <div key={itemKey} className={dashboard.gridItem}>
                  <span className={dashboard.itemIcon}>
                    {item.isFolder ? (
                      <img src={folderIcon} alt="folder" className={dashboard.iconos} />
                    )
                      : (
                        <img src={getFileIcon(item.type)} alt="file" className={dashboard.iconos} />
                      )}
                  </span>
                  <span className={dashboard.gridItemLabel}>{item.name}</span>

                  <button
                    className={dashboard.menuButton}
                    onClick={() => toggleItemMenu(itemKey)}
                  >
                    ⋮
                  </button>

                  {openMenuKey === itemKey && (

                    <div className={dashboard.itemMenu}>
                      <div onClick={() => handleRestore(item.id, item.isFolder)}>Restaurar</div>
                      <div onClick={() => handleDelete(item.id, item.isFolder)}>Borrar</div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
        <button
          onClick={goToMainDashboard}
          className={dashboard.trashButton}
          title="Dashboard"
        >
          <img
            src={goBackActual}
            alt="GoBack"
            className={dashboard.trashIcon}
          />
        </button>
      </main>
    </div>
  )
};

export default DashboardTrash;
